import { EnvironmentConfiguration, SecurityModuleName } from '@jms/model';
import { Injectable, signal } from '@angular/core';

@Injectable()
export class ConfigService {

    private static _config: EnvironmentConfiguration;
    public static get environment(): EnvironmentConfiguration {
        this._config = this._config
            ? this._config
            : { ...window['config'] } as any;
        return this._config;
    }

    public static get origin(): string {
        return ConfigService.window().location.origin;
    }

    public static readonly $preventLogin = signal(ConfigService?.environment?.preventLogin ?? false);

    private static window(): any {
        return window;
    }
}

export const propertyManagementEnabled = ConfigService.environment?.plan?.addons[SecurityModuleName.PropertyManagement] ?? false;
export const workBuddyConnectEnabled = ConfigService.environment?.plan?.addons[SecurityModuleName.WorkBuddyConnect] ?? false;
export const isDevelopment = ConfigService?.environment?.domain?.endsWith('.dev');
